import React, { Fragment } from 'react';
import { Header } from 'formlabs-web-components/Type';
import { Grid, Cell } from 'formlabs-web-components/Grid';

import clientOnly from '../../hoc/clientOnly';
import './Module.module.css';

const Module = ({ children, moduleName }) => {
  let isModulePage = window.location.pathname.includes('admin');
  if (isModulePage) {
    return (
      <div styleName="module">
        <Grid direction="x" hasContainer={true}>
          <Cell>
            <Header level={4} displayAs={4}>
              {moduleName}
            </Header>
          </Cell>
        </Grid>
        {children}
      </div>
    );
  }
  return <Fragment>{children}</Fragment>;
};

export default clientOnly(Module);
